<!-- <app-filter-results [filterBy]="filterBy" [isFilterInAvailable]="false"
    [searchBy]="searchBy" [isSearchingAvailable]="false" (onApplyFilter)="applyFilter($event)"
    (resetFilters)="onResetFilters()" [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)"></app-filter-results> -->

    <app-filter-results [filterBy]="filterBy" [isFilterInAvailable]="false" [isSearchingAvailable]="false"
    (onApplyFilter)="applyFilter($event)" (resetFilters)="onResetFilters()"  [filterOpen]="filterStatusParent" (closeNavEvent)="closeEvent($event)">
</app-filter-results>